<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <template>
            <v-card>
              <v-divider class="m-0"></v-divider>
              <v-col cols="12">
                <v-expansion-panels accordion v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="custom-expansion-panel-header" color="#00004d">
                      <div class="text-center font-weight-bold">
                        Search/Filters
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-form v-on:submit.prevent="hitAdvanceSearch(false)">
                        <v-row>
                          <v-col cols="12" sm="4">
                            <v-autocomplete
                                v-model="searchFormData.vendorSearch"
                                :items="vendorsFilter"
                                item-text="name"
                                item-value="id"
                                clearable
                                outlined
                                dense
                                chips
                                small-chips
                                hide-details
                                deletable-chips
                                @change="vendorChange($event)"
                                label="Select Vendor*"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <span>{{ data.item.name }}</span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="searchFormData.vendorSearch">
                            <v-autocomplete
                                v-model="searchFormData.userSearch"
                                :items="usersFilter"
                                item-text="name"
                                item-value="id"
                                clearable
                                outlined
                                dense
                                chips
                                hide-details
                                small-chips
                                deletable-chips
                                @change="userChange($event)"
                                label="Select User*"
                            >
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="searchFormData.vendorSearch && searchFormData.userSearch">
                            <v-select
                                dense outlined
                                hide-details
                                clearable
                                @change="onDateRangeChange"
                                :items="dateRangeOptions"
                                v-model="searchFormData.drSearch"
                                item-text="title"
                                item-value="value"
                                label="Date Range"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="searchFormData.vendorSearch && searchFormData.userSearch">
                            <v-text-field type="date"
                                          dense outlined
                                          hide-details v-model="searchFormData.fromDateSearch"
                                          label="From Date"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="searchFormData.vendorSearch && searchFormData.userSearch">
                            <v-text-field type="date"
                                          dense outlined
                                          hide-details v-model="searchFormData.toDateSearch"
                                          label="To Date"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="searchFormData.vendorSearch && searchFormData.userSearch"
                                 class="d-flex align-center">
                            <button :disabled="loading" type="submit" style="flex: 1"
                                    class="btn btn-success theme-btn mr-2">
                              Generate
                              <v-icon class="ml-2" small>fas fa-tasks</v-icon>
                            </button>
                            <button :disabled="loading" type="button" style="flex: 1"
                                    @click="hitAdvanceSearch(true)"
                                    class="btn btn-primary">
                              Reset
                              <v-icon class="ml-2" small>fas fa-times</v-icon>
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-divider class="m-0"></v-divider>
              <div v-show="dataLoaded">
                <v-card-title>
                  Custom logs — audit trail ({{ addTSBVZ(totalRecords) }})
                </v-card-title>
                <v-row>
                  <v-col cols="12">
                    <v-pagination
                        color="#00004d"
                        :total-visible="15"
                        @input="refreshData(false)"
                        :disabled="loading"
                        v-model="pagination.page"
                        :length="pageCount">
                    </v-pagination>
                  </v-col>
                </v-row>
                <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"></v-skeleton-loader>
                <v-card-text v-if="!isLoaded" class="pa-2">
                  <v-data-table
                      :headers="tableHeaders"
                      :items="items"
                      :options.sync="pagination"
                      :server-items-length="totalRecords"
                      @update:items-per-page="refreshData(false)"
                      :footer-props="{
                        itemsPerPageOptions: rowsPerPageItems,
                        disablePagination: true
                      }"
                      :loading="loading"
                      mobile-breakpoint="0"
                      dense
                      class="elevation-0 custom-logs-table"
                  >
                    <template v-slot:[`item.tbl_details`]="{ item }">
                      <div class="d-flex align-center justify-center custom-logs-change-cell">
                        <v-btn
                            v-if="hasChangeDetailPayload(item)"
                            icon
                            x-small
                            color="#00004d"
                            title="View change detail"
                            @click.stop="openChangeDetailModal(item)"
                        >
                          <v-icon x-small>fas fa-eye</v-icon>
                        </v-btn>
                        <span v-else class="grey--text">—</span>
                      </div>
                    </template>
                    <template v-slot:[`item.created_at`]="{ item }">
                      {{ formatDateAndTime(item.created_at) }}
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-dialog v-model="changeDetailDialog" max-width="760" scrollable content-class="custom-logs-change-dialog">
                  <v-card>
                    <v-card-title class="headline pb-2" style="background: #00004d; color: #fff;">
                      {{ changeDetailTitle }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                      <p v-if="!changeDetailSections.length" class="grey--text text--darken-1 mb-0">
                        No structured change data for this entry.
                      </p>
                      <div v-for="(section, sIdx) in changeDetailSections" :key="'sec-' + sIdx" class="mb-4">
                        <h4 class="subtitle-1 font-weight-bold mb-1">{{ section.title }}</h4>
                        <p v-if="section.subtitle" class="caption grey--text text--darken-1 mb-2">{{ section.subtitle }}</p>
                        <ul class="custom-logs-change-list pl-0 mb-0">
                          <li v-for="(line, lIdx) in section.lines" :key="'ln-' + sIdx + '-' + lIdx" class="mb-2">
                            <span class="font-weight-medium">{{ line.label }}:</span>
                            <span class="red--text text--darken-2">{{ line.from }}</span>
                            <span class="mx-1">→</span>
                            <span class="green--text text--darken-2">{{ line.to }}</span>
                          </li>
                        </ul>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#00004d" dark text @click="changeDetailDialog = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-row>
                  <v-col cols="12">
                    <v-pagination
                        color="#00004d"
                        :total-visible="15"
                        @input="refreshData(false)"
                        :disabled="loading"
                        v-model="pagination.page"
                        :length="pageCount">
                    </v-pagination>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {GET_ACTIVITY_LOGS} from "@/core/services/store/users.module";
import {GET_VENDORS_DETAILS, VENDORS_SIMPLE_FULL_LIST} from "@/core/services/store/vendors.module";
import customLogsGridMixin from "@/view/pages/realstate/logs/customLogsGrid.mixin";

export default {
  name: 'custom-activity-logs',
  mixins: [customLogsGridMixin],
  data() {
    return {
      panel: 0,
      draw: 1,
      searchQuery: "",
      loading: false,
      dataLoaded: false,
      isLoaded: true,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        itemsPerPage: 25,
        totalItems: 0,
        sortBy: ['created_at'],
        sortDesc: [true],
      },
      totalRecords: 0,
      headerindex: "",
      columns: [],
      headers: [
        {
          text: 'User',
          value: 'user_id',
          name: 'user_id',
          filterable: false,
          sortable: false
        },
        {
          text: "Created",
          value: "created_at",
          name: "created_at",
          filterable: false,
          sortable: true
        },
        {text: "Updated", value: "updated_at", name: "updated_at", filterable: false, sortable: false},
        {text: 'Action', value: 'actions', data: null, name: null, filterable: false, sortable: false},
      ],
      items: [],
      vendorsFilter: [],
      usersFilter: [],
      searchFormData: {
        drSearch: '0',
        vendorSearch: '',
        userSearch: '',
        fromDateSearch: '',
        toDateSearch: '',
      },
    }
  },
  mounted() {
    for (var i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].data +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.getVendors();
  },
  methods: {
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData(logActivity = false) {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        const per = params.itemsPerPage || params.rowsPerPage || 25;
        params.length = per;
        params.start = params.page == 1 ? 0 : per * (params.page - 1);
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        let searchFormDataQuery = Object.keys(this.searchFormData).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(this.searchFormData[key])
        }).join('&');
        const sortBy = Array.isArray(params.sortBy) && params.sortBy.length ? params.sortBy : ['created_at'];
        const sortDesc = Array.isArray(params.sortDesc) ? params.sortDesc : [true];
        this.getHeaderIndex(sortBy[0]);
        query += '&' + searchFormDataQuery
        if (logActivity) {
          query += '&custom_logs_activity_log=1';
        }
        query +=
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            (sortBy.length === 0 ? 1 : this.headerindex) +
            "&order[0][dir]=" +
            (sortDesc[0] ? "desc" : "asc");
        this.$store.dispatch(GET_ACTIVITY_LOGS, {
          userId: this.searchFormData.userSearch,
          q: query,
          columns: this.columns
        }).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    hitAdvanceSearch(reset = false) {
      this.pagination.page = 1
      if (reset) {
        this.searchFormData = {
          drSearch: '0',
          vendorSearch: '',
          userSearch: '',
          fromDateSearch: '',
          toDateSearch: '',
        };
        this.dataLoaded = false;
        this.items = [];
        this.totalRecords = 0;
        return;
      }
      const hasDateRange = this.searchFormData.fromDateSearch && this.searchFormData.toDateSearch;
      const isAll = this.searchFormData.drSearch === 'all';
      if (this.searchFormData.vendorSearch && this.searchFormData.userSearch && (hasDateRange || isAll)) {
        this.loadData(true).then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
          this.dataLoaded = true
        });
      }
    },
    getVendors() {
      this.$store.dispatch(VENDORS_SIMPLE_FULL_LIST).then((data) => {
        this.vendorsFilter = data.records.vendorsList;
      });
    },
    getVendorUsers(id) {
      this.$store.dispatch(GET_VENDORS_DETAILS, id).then((data) => {
        this.usersFilter = data.records.all_users
      })
    },
    vendorChange(evt) {
      this.searchFormData.userSearch = ''
      if (evt) {
        this.getVendorUsers(evt)
      }
    },
    userChange(evt) {
      if (evt) {
        this.searchFormData.drSearch = '0'
        this.drChange("0")
        this.hitAdvanceSearch(false)
      }
    },
    onDateRangeChange(v) {
      this.drChange(v)
      this.hitAdvanceSearch(false)
    },
    drChange(v) {
      if (v) {
        if (v === "all") {
          this.searchFormData.fromDateSearch = ''
          this.searchFormData.toDateSearch = ''
        } else if (v === "0") {
          let date = new Date();
          let today = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          this.searchFormData.toDateSearch = today
          this.searchFormData.fromDateSearch = today
        } else if (v === "1") {
          let date = new Date();
          let cdate = new Date();
          let lastmonths = new Date(cdate.setMonth(cdate.getMonth() - 1));
          let toDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          let fromDate = lastmonths.getFullYear() + '-' + ('0' + (lastmonths.getMonth() + 1)).slice(-2) + '-' + ('0' + lastmonths.getDate()).slice(-2);
          this.searchFormData.toDateSearch = toDate
          this.searchFormData.fromDateSearch = fromDate
        } else if (v === "2") {
          let date = new Date();
          let cdate = new Date();
          let last3months = new Date(cdate.setMonth(cdate.getMonth() - 2));
          let toDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          let fromDate = last3months.getFullYear() + '-' + ('0' + (last3months.getMonth() + 1)).slice(-2) + '-' + ('0' + last3months.getDate()).slice(-2);
          this.searchFormData.toDateSearch = toDate
          this.searchFormData.fromDateSearch = fromDate
        } else if (v === "3") {
          let date = new Date();
          let cdate = new Date();
          let last6months = new Date(cdate.setMonth(cdate.getMonth() - 5));
          let toDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          let fromDate = last6months.getFullYear() + '-' + ('0' + (last6months.getMonth() + 1)).slice(-2) + '-' + ('0' + last6months.getDate()).slice(-2);
          this.searchFormData.toDateSearch = toDate
          this.searchFormData.fromDateSearch = fromDate
        } else if (v === "4") {
          let date = new Date();
          let toDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          let fromDate = (date.getFullYear() - 1) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          this.searchFormData.toDateSearch = toDate
          this.searchFormData.fromDateSearch = fromDate
        } else if (v === "5") {
          let date = new Date();
          let toDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
          let fromDate = date.getFullYear() + '-01-01';
          this.searchFormData.toDateSearch = toDate
          this.searchFormData.fromDateSearch = fromDate
        }
      } else {
        this.searchFormData.toDateSearch = this.$store.state.auth.c_d
        this.searchFormData.fromDateSearch = this.$store.state.auth.c_d
      }
    },
  },
  computed: {
    dateRangeOptions() {
      return [
        {value: '0', title: '1 Day'},
        ...this.dateRangeFilter,
        {value: 'all', title: 'All'},
      ];
    },
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery
      };
    },
    ...mapState({
      errors: state => state.users.errors
    }),
    pageCount() {
      const per = this.params.itemsPerPage || this.params.rowsPerPage || 25;
      return per <= this.totalRecords ? Math.ceil(this.totalRecords / per) : 0;
    }
  }
};
</script>

<style scoped>
.custom-logs-table ::v-deep td {
  vertical-align: top;
  white-space: normal !important;
  word-break: break-word;
  font-size: 0.875rem;
  line-height: 1.4;
}
.custom-logs-table ::v-deep th {
  white-space: nowrap;
}
.custom-logs-table ::v-deep .v-data-footer__icons-before,
.custom-logs-table ::v-deep .v-data-footer__icons-after {
  display: none !important;
}
.custom-logs-change-cell {
  min-height: 32px;
}
.custom-logs-change-list {
  list-style: none;
}
</style>
